// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"66596aaf","118":"0004b9d3","252":"07024f2e","505":"58ac8069","666":"7ebcedbc","848":"37387e6f"}[chunkId] + ".chunk.js";
};